import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { links } from '@core/router';
import {
    ActivityType,
    CompositePointSourceType
} from '@api/FitnessActivityClient';

import {
    PointDefinitionForm,
    PointDefinitionFormData
} from '../point-definition-form';
import { useCreatePointDefinitionStore } from './store';

export const CreatePointDefinitionForm = () => {
    const { communityId } = useParams();
    const navigate = useNavigate();

    const communityIdNum = Number(communityId);
    const { createRequest, onSubmit } =
        useCreatePointDefinitionStore(communityIdNum);

    if (isNaN(communityIdNum)) return null;

    const handleSubmit = async (formData: PointDefinitionFormData) => {
        await onSubmit({
            communityId: communityIdNum,
            pointTypeKey: formData.pointTypeKey,
            label: formData.label,
            symbolSvg: formData.symbolSvg
                ? btoa(formData.symbolSvg)
                : undefined,
            enabled: formData.enabled,
            dayFrom: formData.dayFrom || undefined,
            sourceRules: formData.rules.map((rule) => ({
                sourceType: rule.sourceType as CompositePointSourceType,
                sourceKey: rule.sourceKey || undefined,
                workoutCategory:
                    rule.sourceType ===
                        CompositePointSourceType.ACTIVITY_POINTS &&
                    rule.sourceKey === ActivityType.WORKOUT
                        ? rule.workoutCategory || undefined
                        : undefined,
                workoutType:
                    rule.sourceType ===
                        CompositePointSourceType.ACTIVITY_POINTS &&
                    rule.sourceKey === ActivityType.WORKOUT
                        ? rule.workoutType || undefined
                        : undefined,
                expression: rule.expression,
                priority: parseInt(rule.priority, 10),
                enabled: rule.enabled
            }))
        });
    };

    return (
        <PointDefinitionForm
            title="Create Point Definition"
            submitLabel="Create"
            submittingLabel="Creating..."
            isSubmitting={createRequest.loading}
            onCancel={() =>
                navigate(links.communityPointDefinitions(communityId))
            }
            onSubmit={handleSubmit}
        />
    );
};

export default CreatePointDefinitionForm;
